import i18next from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import * as en from "@/src/common/locales/en";
import * as es from "@/src/common/locales/es";

const resources = { en, es };

export const LANGUAGES = {
	en: "English",
	es: "Español",
} as const;

export type Language = keyof typeof LANGUAGES;

export const OG_LOCALE: Record<Language, string> = {
	en: "en_US",
	es: "es_ES",
};

const NAMESPACES = {
	common: "common",
	home: "home",
	features: "features",
	pricing: "pricing",
	about: "about",
	contact: "contact",
	careers: "careers",
	legal: "legal",
} as const;

type Namespace = keyof typeof NAMESPACES;

export const DEFAULT_LANGUAGE: Language = "en";
const DEFAULT_NAMESPACE: Namespace = "common";
export const LANGUAGE_QUERY_PARAM = "lng";

const isLanguage = (value: string | undefined): value is Language => value !== undefined && value in LANGUAGES;

export const toLanguage = (value: string | undefined): Language => (isLanguage(value) ? value : DEFAULT_LANGUAGE);

const isBrowser = typeof window !== "undefined";

const instance = isBrowser ? i18next.use(LanguageDetector) : i18next;

void instance.use(initReactI18next).init({
	resources,
	ns: Object.values(NAMESPACES),
	defaultNS: DEFAULT_NAMESPACE,
	fallbackNS: DEFAULT_NAMESPACE,
	fallbackLng: DEFAULT_LANGUAGE,
	supportedLngs: Object.keys(LANGUAGES),
	interpolation: { escapeValue: false },
	react: { useSuspense: true },
	nsSeparator: ":",
	keySeparator: ".",
	...(isBrowser
		? {
				detection: {
					order: ["querystring", "cookie", "navigator"],
					lookupQuerystring: LANGUAGE_QUERY_PARAM,
					lookupCookie: "upsquad-landing-locale",
					caches: ["cookie"],
				},
			}
		: { lng: DEFAULT_LANGUAGE }),
});

export default i18next;
